export default "__VITE_PUBLIC_ASSET__1b51f7ec__"